import { useState } from "react";
import CustomButton from "./CustomButton";

import { useTranslation } from "react-i18next";
import AddKassaModal from "./AddKassaModal";

export default function AddKassaProcess({
  icon = { link: "", size: 0, variant: "blank" },
  onKassaCreated = () => {},
}) {

  const [showKassaModal, setShowKassaModal] = useState(false);
  const { t } = useTranslation("general");



  return (
    <>
      <CustomButton
        title={t("addKassa")}
        variant={icon.variant}
        icon={icon.link}
        iconSize={icon.size}
        onClick={() => setShowKassaModal(true)}
      />

        {showKassaModal && (
            <AddKassaModal setShowKassaModal={setShowKassaModal} />
        )}

    </>
  );
}
